export const environment = {
  production: true,
  environment: 'stag',
  serverUrl: 'http://52.52.236.205:4002/api/',
  s3ItemThumbImage: 'https://s3-us-west-1.amazonaws.com/zenfoods/items/thumbnail/',
  s3ItemThumbImageLarge: 'https://s3-us-west-1.amazonaws.com/zenfoods/items/web/',
  s3categoryThumbImageLarge: 'https://s3-us-west-1.amazonaws.com/zenfoods/categories/thumbnail/',
  s3categoryImageLarge: 'https://s3-us-west-1.amazonaws.com/zenfoods/categories/web/',
  itemCropThumbnailUrl: 'https://s3-us-west-1.amazonaws.com/zenfoods/items/thumbnail_c/',
  profileWebUrl: 'https://s3-us-west-1.amazonaws.com/zenfoods/profiles/thumbnail/',
  profileAppUrl: 'https://s3-us-west-1.amazonaws.com/zenfoods/profiles/thumbnail/',
  profileThumbnailUrl: 'https://s3-us-west-1.amazonaws.com/zenfoods/profiles/thumbnail/',
  profileSmallThumbnailUrl: 'https://s3-us-west-1.amazonaws.com/zenfoods/profiles/thumbnail/',
  stripeKey: 'pk_test_K12kb5EMid9kuleiYGFrhxER'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts